export type { ApiResponse } from './clients/base.client';
export { ApiError } from './clients/base.client';

// Shows service client — Shows/Theatres listing & home page
export { ShowsClient, showsClient, applyPricingCoefficients } from './clients/shows.client';
export type {
  ShowListRecord,
  ShowsFacetOption,
  ShowsFilterFacets,
  ShowsSortKey,
  ShowsSearchResponse,
  SearchShowsParams,
  ShowCitySuggestion,
  ShowNameSuggestion,
  ShowNameSuggestionResult,
  InitiateTheatreSearchResponse,
  ShowDetailExtras,
  ReserveTicketsBody,
  GuestDetailsFormData,
  GuestDetailsResult,
  OrderSummaryResponse,
  OrderSummaryTicket,
  ConfirmPaymentBody,
  BookingDetailResponse,
  BookingDetailTicket,
  AreaPriceRow,
  PricingCoefficients,
  // Manage-bookings "Shows" tab display types — served by sports-events-service's own `/shows`
  // module, but typed here since they describe Shows/theatre booking data, not sports/concerts.
  ShowBooking,
  ShowBookingBasketItem,
  ShowBookingBasketTicket,
  ShowBookingPaymentDetails,
  ShowsBookingListItem,
  ShowsBookingsListResponse,
  ShowBookingDetailTicket,
  ShowBookingDetailData,
  ShowBookingDetailResponse,
  ShowETicketPayload,
} from './clients/shows.client';

// Common service client — currencies and shared platform features
export { CommonClient, commonClient } from './clients/common.client';
export type { CurrencyItem, GeoData, CountryItem } from './clients/common.client';

// Sports events service client
export { SportsEventsClient, sportsEventsClient, concertsEventsClient } from './clients/sportsevents.client';
export type {
  SearchEventsParams,
  Event,
  PaginatedEvents,
  Ticket,
  PaginatedTickets,
  GuestInfo,
  CreateBookingRequest,
  Booking,
  CheckoutSession,
  PaymentIntent,
  BookingStatus,
  PaymentStatus,
  TopCity,
  TopTournament,
  FilterOptions,
  FilterOptionItem,
  Country,
  NearbyShow,
  NearbyHotel,
  NearbySportEvent,
  SportsBookingListItem,
  SportsBookingsListResponse,
} from './clients/sportsevents.client';

// Auth service client
export { AuthClient, authClient } from './clients/auth.client';
export type { AuthResponse, MeResponse, MemberProfile, ProfileResponse } from './clients/auth.client';

// Hotels service client
export { HotelsClient, hotelsClient } from './clients/hotels.client';

// Restaurants service client
export { RestaurantsClient, restaurantsClient } from './clients/restaurants.client';
export type {
  SearchRestaurantsParams,
  RestaurantRecord,
  RestaurantListResponse,
  RestaurantAddress,
  RestaurantLocation,
  OpeningHourRecord,
  AvailabilitySlot,
  AvailableTable,
  BookingFlowTable,
  AvailableDateRange,
  CreateRestaurantBookingParams,
  RestaurantBooking,
  RestaurantBookingListItem,
  RestaurantBookingsListResponse,
  LocationSuggestion,
  CityDestIdResult,
  BookingFlowTimesBlock,
  BookingFlowTimesResponse,
  NearbySportsParams,
  NearbySportsResponse,
  NearbyShowsParams,
  NearbyShowsResponse,
  NearbyHotelsParams,
  NearbyHotelsResponse,
  NearbyRestaurantsParams,
  NearbyRestaurantRecord,
  NearbyRestaurantsResponse,
} from './clients/restaurants.client';
export type {
  HotelSearchParams,
  HotelNearbyGeoParams,
  FinalRate,
  FacetOption,
  AffiliateVenueMeta,
  RefVenueMeta,
  HotelListRecord,
  SearchListResponse,
  HotelSuggestion,
  Suggestions,
  FeaturedHotel,
  RecommendedRoom,
  PropertyDetailResponse,
  PropertyDetailParams,
  SelectedRoomRateInput,
  PrepareCartBody,
  PrepareCartResult,
  CartData,
  CartFinalRatesObj,
  PaymentScheduleRow,
  BookingListItem,
  BookingsListResponse,
  BookingDetail,
  CancelBookingResult,
  UpdateBookingCardResult,
  ChatAttachment,
  ChatMessage,
  ChatMessagesResponse,
  SendChatMessageResult,
  GuestDetailsBody,
  AccessibilityRequests,
  CotAndExtraBedItem,
  CotExtraBedBand,
  InitiatePaymentResult,
  SavePaymentBody,
  SavePaymentResult,
  // Phase 0.12: UPO + cancellation types
  RateLevelUPO,
  RoomBookingUPO,
  CancellationPolicyEntry,
  CancellationChargeType,
  BookedPolicyContext,
  NearbyShowItem,
  NearbyShowsResult,
} from './clients/hotels.client';
